import React from "react";
import MuiActions from "@material-ui/core/DialogActions";

import withStyles from "../../../styles/withStyles";

function Actions(props) {
  return <MuiActions {...props} />;
}

let styles = theme => ({
  root: {
    paddingTop: "22px",
    justifyContent: "center"
  }
});

export default withStyles(styles)(Actions);
